export default "__VITE_ASSET__ece84885__"